import { Badge, Box, Button, ImageList, Paper, Typography } from '@mui/material'
import React, { useContext, useRef, useState } from 'react'
import DeleteIcon from '@mui/icons-material/Delete'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner'
import API from '../../../../services/API'
import { IncidentContext } from './ReportIncident'

const Step7 = ({ setLoading }) => {
  const { setFormValues, setTab } = useContext(IncidentContext)
  const [files, setFiles] = useState([])
  const fileInput = useRef()
  const handleNext = async (e) => {
    e.preventDefault()
    setLoading(true)

    // Each upload is fully awaited (URL mint + S3 PUT) so the submit step
    // can't run before the files actually exist in the bucket.
    const uploadFiles = () =>
      Promise.all(
        files.map(async (file) => {
          // TODO: Should this be done on the backend instead of sharing URL to frontend?
          const res = await API.post('/gets3uploadurl', {
            folder: 'governance/incidents',
            extension: file.type.split('/')[1],
          })
          await API.put(res.data.url, file, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          return res.data.key
        }),
      )

    try {
      const filePaths = await uploadFiles()
      setFormValues((prev) => ({
        ...prev,
        files: filePaths,
      }))
      setTab((prev) => prev + 1)
      window.scrollTo(0, 0)
    } finally {
      setLoading(false)
    }
  }

  const handleFileUpload = (e) => {
    const file = e.target.files[0]
    const fileType = file.name.split('.').slice(-1)[0]
    if (['jpeg', 'jpg', 'png', 'gif'].includes(fileType)) {
      file.localURL = URL.createObjectURL(e.target.files[0])
    } else if (fileType === 'pdf') {
      file.localICON = <PictureAsPdfIcon sx={{ fontSize: 40 }} />
    } else {
      file.localICON = <DocumentScannerIcon sx={{ fontSize: 40 }} />
    }
    setFiles((prev) => [...prev, file])
  }

  const handleDeleteFile = (index) =>
    setFiles((prev) => prev.filter((x, i) => i !== index))

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={3}
      onSubmit={handleNext}
      component="form"
    >
      <Typography variant="title2" fontSize="1rem">
        Attachments
      </Typography>
      <Box justifyContent="center" display="flex">
        <Button
          variant="contained"
          color="anBlue"
          onClick={() => fileInput.current.click()}
        >
          Add an Attachment
        </Button>
        <input
          ref={fileInput}
          type="file"
          accept="image/*, application/pdf, .doc, .docx"
          onChange={handleFileUpload}
          style={{ display: 'none' }}
        />
      </Box>
      <Box display="flex" gap={2}>
        {files.map((file, index) => (
          <Box
            key={index + file.name}
            component={Paper}
            padding={1}
            maxHeight={150}
            display="inline-flex"
            position="relative"
            minHeight={150}
            minWidth={100}
            justifyContent="center"
            alignItems="center"
          >
            {file.localURL && (
              <Box
                component="img"
                src={file.localURL}
                sx={{
                  objectFit: 'contain',
                  maxWidth: '100%',
                  maxHeight: '100%',
                }}
              />
            )}
            {file.localICON && (
              <Box
                display="flex"
                flexDirection="column"
                gap={2}
                alignItems="center"
                justifyContent="center"
              >
                <Box>{file.localICON}</Box>
                <Typography variant="caption">{file.name}</Typography>
              </Box>
            )}

            <Box
              sx={{
                position: 'absolute',
                right: -10,
                top: -10,
                bgcolor: '#8b0000',
                padding: 0.5,
                borderRadius: 1,
                cursor: 'pointer',
              }}
              display="flex"
              onClick={() => handleDeleteFile(index)}
            >
              <DeleteIcon sx={{ color: 'white' }} />
            </Box>
          </Box>
        ))}
      </Box>
      <Box display="flex" gap={1} justifyContent="flex-end">
        <Button
          variant="outlined"
          color="primary"
          onClick={() => setTab((prev) => prev - 1)}
        >
          Previous
        </Button>
        <Button variant="contained" color="primary" type="submit">
          Next
        </Button>
      </Box>
    </Box>
  )
}

export default Step7
